module.exports = __webpack_public_path__ + "img/sidebar_superlig_202627.06d239e6.png";